import { call, put } from "redux-saga/effects";
import { APIS, ACTIONS } from "../../_config";
import { CallApi } from "../api/callApi";
import { sagaFunction } from "../api/functions";

export function* settingReturnInsertUpdate(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.SETTINGS_RETURN.SETTING_RETURN_INSERT_UPDATE, action.payload, true);
}

export function* getSettingReturnPolicy(action: any): any {
    const yieldPuts = [
        {
            type: ACTIONS.MASTER.RETURN_REASONS,
            payload: "returnPolicyReasons"
        }
    ];
    yield call(sagaFunction, action, CallApi.GET, APIS.SETTINGS_RETURN.GET_SETTING_RETURN_POLICY, action.payload, true, yieldPuts);
}